import React from "react";
import AnchorPointGrid from "./grid";
import AnchorPointMap from "./map";
import { withStyles, withTheme } from "@material-ui/core";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { observer, inject } from "mobx-react";
import AddUpdateAnchorPoint from "./addUpdateAnchorPoint";
import Events from "../../../../../utilities/EventEmitter";
import {
  getAnchorPointData,
  getTrailersData,
  getRoutesDataForPlanning
} from "../../../../../utilities/fetchData";
import { isDispatchHeaderActive } from "../../utils";

const styles = {
  anchorPointSubModule: {
    height: "100%",
    display: "flex",
    "&>div": {
      width: "50%",
      boxSizing: "border-box",
    },
    "&>.addUpdateAnchorPointForm": {
      width: "15%",
    },
  },
};
@inject("CommonStore", "IBPlanningStore")
@observer
class AnchorPoint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAnchorPoints: [],
      errorMessage: null,
      zoneInfo: null,
      isAddUpdateAnchorPointFormOpen: false,
      anchorPointsInfo: null,
      anchorPointsPosition: null,
    };
  }

  componentDidMount() {
    if (
      this.props.CommonStore.anchorPointData.terminalCode !==
      this.props.userData.userProfile.terminal.code
    ) {
      /*
        When the terminal changes, we already have logic in the IBPlanning header to update anchor points. 
        Here, we ensure that the anchor point is updated only when the user navigates to the anchor point tab through the dispatch module.
      */
      if (isDispatchHeaderActive()) {
        this.updateAnchorPointDataInStore();
        this.updateTrailerDataInStore();
        this.fetchAndUpdateRouteData();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.userData.userProfile.terminal.code !== this.props.userData.userProfile.terminal.code
    ) {
      /*
        When the terminal changes, we already have logic in the IBPlanning header to update anchor points. 
        Here, we ensure that the anchor point is updated only when the user navigates to the anchor point tab through the dispatch module.
      */
      if (isDispatchHeaderActive()) {
        this.updateAnchorPointDataInStore();
        this.updateTrailerDataInStore();
        this.fetchAndUpdateRouteData();
      }
    }
    if (this.props.userData.userProfile.scenarioID !== prevProps.userData.userProfile.scenarioID) {
      this.addUpdateAnchorPointClose();
    }
  }

  // Fetch and update route data in IBPlanningStore to populate route dropdown options in anchor point grid
  fetchAndUpdateRouteData = () => {
    const routesListPromise = getRoutesDataForPlanning(this.props.userData.userProfile.scenarioID);
    routesListPromise.then((routes) => {
      if ( routes.status === 200 ) {
        this.props.IBPlanningStore.addRoutes(routes.data, this.props.theme.routeMapColorPalette.IconsColors)
      } else {
        this.props.IBPlanningStore.addRoutes([], [])
      }
    });
  }

  anchorPointClickedOnMap = (anchorPoint) => {
    if (!this.state.isAddUpdateAnchorPointFormOpen) {
      this.setState({
        selectedAnchorPoints: anchorPoint ? [anchorPoint.data] : [],
        zoneInfo: null,
      });
    }
  };

  anchorPointSelectedOnGrid = (anchorPoints) => {
    this.setState({
      selectedAnchorPoints: anchorPoints ? anchorPoints : [],
      zoneInfo:
        anchorPoints && anchorPoints.length ? null : this.state.zoneInfo,
    });
  };

  onDataUpdated = () => {
    // force rerender when store is not refreshed but data is updated
    this.forceUpdate();
  };


  updateAnchorPointDataInStore = async () => {
    const { scenarioID, terminal } = this.props.userData.userProfile;
    let { success, data } = await getAnchorPointData(scenarioID, terminal);
    this.props.CommonStore.updateAnchorPointsData(data, terminal.code);
    if (success && !isDispatchHeaderActive()) Events.emit('RefreshIBStore');
  };

  updateTrailerDataInStore = async () => {
    const { terminal } = this.props.userData.userProfile;
    const trailerData = await getTrailersData(terminal);
    this.props.CommonStore.updateTrailersData(trailerData);
  };

  addUpdateAnchorPointClose = () => {
    this.setState({
      isAddUpdateAnchorPointFormOpen: false,
      anchorPointsInfo: null,
      anchorPointsPosition: null,
    });
  };
  addAnchorPointOpen = () => {
    this.setState({
      isAddUpdateAnchorPointFormOpen: true,
      anchorPointsInfo: null,
      selectedAnchorPoints: [],
      anchorPointsPosition: null,
    });
  };
  updateAnchorPointOpen = () => {
    this.setState({
      isAddUpdateAnchorPointFormOpen: true,
      anchorPointsInfo: this.state.selectedAnchorPoints[0],
    });
  };
  anchorPointsPositionChange = (anchorPointsPosition) => {
    if (
      anchorPointsPosition?.latitude !==
        this.state.anchorPointsPosition?.latitude &&
      anchorPointsPosition?.longitude !==
        this.state.anchorPointsPosition?.longitude
    ) {
      this.setState({
        anchorPointsPosition: anchorPointsPosition,
      });
    }
  };
  onZoneClicked = (zoneInfo) => {
    this.setState({
      selectedAnchorPoints: [],
      zoneInfo,
    });
  };

  render() {
    const { classes } = this.props;
    const { errorMessage, selectedAnchorPoints, zoneInfo } = this.state;
    const anchorPointList = this.props.CommonStore.anchorPointData.anchorPointList;
    const anchorPointData = anchorPointList ? anchorPointList.slice() : [];
    const selectedAnchorPoint = selectedAnchorPoints.map((anchorPoint) => anchorPoint.anchorPointName);

    return (
      <div className={classes.anchorPointSubModule}>
        <AnchorPointGrid
          data={anchorPointData}
          error={errorMessage}
          selectedAnchorPoints={selectedAnchorPoint}
          anchorPointSelectedOnGrid={this.anchorPointSelectedOnGrid}
          onDataUpdated={this.onDataUpdated}
          scenarioId={this.props.userData.userProfile.scenarioID}
          addAnchorPointOpen={this.addAnchorPointOpen}
          updateAnchorPointOpen={this.updateAnchorPointOpen}
          updateAnchorPointDataInStore={this.updateAnchorPointDataInStore}
          isAddUpdateAnchorPointFormOpen={
            this.state.isAddUpdateAnchorPointFormOpen
          }
          anchorPointsInfo={this.state.anchorPointsInfo}
        />
        <AnchorPointMap
          onTerminalChange={this.onTerminalChange}
          onAnchorPointClicked={this.anchorPointClickedOnMap}
          selectedAnchorPoints={selectedAnchorPoint}
          zoneInfo={zoneInfo}
          onZoneClicked={this.onZoneClicked}
          isAddUpdateAnchorPointFormOpen={
            this.state.isAddUpdateAnchorPointFormOpen
          }
          anchorPointsInfo={this.state.anchorPointsInfo}
          anchorPointsPosition={this.state.anchorPointsPosition}
          anchorPointsPositionChange={this.anchorPointsPositionChange}
          userData={this.props.userData}
        />
        {this.state.isAddUpdateAnchorPointFormOpen ? (
          <AddUpdateAnchorPoint
            data={anchorPointData}
            onClose={this.addUpdateAnchorPointClose}
            anchorPointsInfo={this.state.anchorPointsInfo}
            scenarioId={this.props.userData.userProfile.scenarioID}
            anchorPointsPosition={this.state.anchorPointsPosition}
            anchorPointsPositionChange={this.anchorPointsPositionChange}
            updateAnchorPointDataInStore={this.updateAnchorPointDataInStore}
          />
        ) : null}
      </div>
    );
  }
}

export default compose(withStyles(styles), withUserProfile, withTheme())(AnchorPoint);
